import gqlRequest from 'graphql/generic';
import { Roles } from '../types';

type getRolesReturn = {
  getRoles: Roles[];
};

const getRolesQuery = `
  query GetRoles {
    getRoles {
      _id
      description
      permissions {
        element
        kind
      }
    }
  }
`;

export const GQLGetRoles = () => gqlRequest<getRolesReturn>(getRolesQuery);
